// extracted by mini-css-extract-plugin
export default {"blockSelector":"style_blockSelector__zftfp","carouselContainer":"style_carouselContainer__j8pcR","uninteracted":"style_uninteracted__-hz-Z","breathe":"style_breathe__AB5Ot"};